/**
 * The browser adapter behind `IdPort` — the composition root (`system/pwa/kernel-runtime.ts`)
 * constructs this instead of calling `globalThis.crypto.randomUUID()` inline, keeping browser
 * I/O out of the composition root (boundary rules B3/B4) the same way `BrowserClock` keeps
 * `setTimeout`/`Date` out of it.
 */
export class BrowserId {
    #randomUUID;
    constructor(options = {}) {
        this.#randomUUID = options.randomUUID ?? (() => globalThis.crypto.randomUUID());
    }
    generate() {
        return this.#randomUUID();
    }
}
//# sourceMappingURL=browser-id.js.map